import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c4da9b58&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=c4da9b58&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4da9b58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4da9b58')) {
      api.createRecord('c4da9b58', component.options)
    } else {
      api.reload('c4da9b58', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c4da9b58&scoped=true", function () {
      api.rerender('c4da9b58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/setting/auth/group/index.vue"
export default component.exports